export const previewFlow = [
  {
    icon: "ri-user-voice-line",
    title: "Você apresenta sua empresa",
    description: "Conte o que o seu negócio faz, quais serviços oferece e o estilo que combina com a sua marca.",
  },
  {
    icon: "ri-draft-line",
    title: "Nós planejamos a estrutura",
    description: "Organizamos as seções e a jornada do visitante de acordo com o objetivo da empresa.",
  },
  {
    icon: "ri-palette-line",
    title: "Criamos uma proposta visual",
    description: "Desenvolvemos uma prévia inicial com direção de design, cores e hierarquia visual.",
  },
  {
    icon: "ri-eye-line",
    title: "Você visualiza a ideia",
    description: "Recebe uma proposta concreta para enxergar como a sua presença digital poderia ficar.",
  },
  {
    icon: "ri-arrow-right-double-line",
    title: "Depois decidimos os próximos passos",
    description: "Sem pressão: você avalia com calma e, se fizer sentido, seguimos com o projeto.",
  },
];

export const deliverables = [
  {
    icon: "ri-palette-line",
    title: "Design moderno",
    description: "Layouts atuais, profissionais e personalizados de acordo com a identidade da empresa.",
  },
  {
    icon: "ri-smartphone-line",
    title: "Responsivo",
    description: "Seu site adaptado para celular, tablet, notebook e computador.",
  },
  {
    icon: "ri-speed-up-line",
    title: "Alta performance",
    description: "Estrutura otimizada para oferecer carregamento rápido e boa experiência ao visitante.",
  },
  {
    icon: "ri-search-eye-line",
    title: "SEO",
    description: "Estrutura preparada com boas práticas de SEO para facilitar a compreensão do conteúdo pelos mecanismos de busca.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Segurança",
    description: "Implementação de boas práticas de segurança e HTTPS/SSL quando aplicável.",
  },
  {
    icon: "ri-focus-3-line",
    title: "Conversão",
    description: "Estrutura pensada para facilitar contatos, solicitações de orçamento, vendas e outras ações importantes.",
  },
];

export const previewSegments = [
  "Ainda não tenho site",
  "Quero criar um novo site",
  "Quero modernizar meu site",
  "Quero melhorar o desempenho",
  "Quero melhorar o visual",
  "Quero melhorar o SEO",
  "Quero vender pela internet",
  "Outro",
];

export const howItWorks = [
  {
    icon: "ri-chat-3-line",
    title: "Você conta sobre sua empresa",
    description: "Envie algumas informações sobre a sua empresa, seus serviços e o que deseja transmitir aos seus clientes.",
  },
  {
    icon: "ri-draft-line",
    title: "Planejamos a proposta",
    description: "Analisamos o seu segmento, público e objetivos para definir uma direção visual.",
  },
  {
    icon: "ri-window-line",
    title: "Criamos a prévia",
    description: "Desenvolvemos uma proposta visual inicial para você conhecer uma possível estrutura para o seu novo site.",
  },
  {
    icon: "ri-check-double-line",
    title: "Você decide",
    description: "Depois de conhecer a proposta, conversamos sobre o projeto, funcionalidades e próximos passos.",
  },
];

export const customReasons = [
  {
    icon: "ri-fingerprint-line",
    title: "Identidade da marca",
    description: "Visual alinhado ao posicionamento e à personalidade da sua empresa.",
  },
  {
    icon: "ri-user-heart-line",
    title: "Experiência do usuário",
    description: "Navegação clara, agradável e fácil de entender em qualquer dispositivo.",
  },
  {
    icon: "ri-layout-4-line",
    title: "Estrutura de conteúdo",
    description: "Informações organizadas na ordem certa, para o visitante encontrar o que precisa.",
  },
  {
    icon: "ri-flag-2-line",
    title: "Objetivos comerciais",
    description: "O site é planejado em função do que o negócio precisa alcançar.",
  },
  {
    icon: "ri-group-line",
    title: "Público-alvo",
    description: "Linguagem e visual pensados para quem realmente vai contratar você.",
  },
  {
    icon: "ri-vip-diamond-line",
    title: "Diferenciais da empresa",
    description: "Destacamos o que faz o seu negócio ser melhor que a concorrência.",
  },
];

export const speedHighlights = [
  "Estrutura otimizada",
  "Imagens otimizadas",
  "Código eficiente",
  "Responsividade",
  "Boas práticas de performance",
  "Preparação para Core Web Vitals",
  "Carregamento otimizado",
];

export const seoHighlights = [
  "Estrutura de títulos H1, H2 e H3",
  "URLs amigáveis",
  "Meta title",
  "Meta description",
  "Sitemap",
  "Robots.txt",
  "Imagens com atributos alt",
  "Estrutura semântica",
  "Performance",
  "Responsividade",
  "Integração com ferramentas de análise",
];

export const conversionExamples = [
  { icon: "ri-file-list-3-line", label: "Solicitar orçamento" },
  { icon: "ri-whatsapp-line", label: "Falar pelo WhatsApp" },
  { icon: "ri-calendar-check-line", label: "Agendar atendimento" },
  { icon: "ri-layout-grid-line", label: "Conhecer serviços" },
  { icon: "ri-shopping-bag-3-line", label: "Comprar produto" },
  { icon: "ri-mail-send-line", label: "Solicitar contato" },
];

export const siteFeatures = [
  { icon: "ri-whatsapp-line", label: "WhatsApp" },
  { icon: "ri-file-list-3-line", label: "Formulários" },
  { icon: "ri-map-pin-2-line", label: "Google Maps" },
  { icon: "ri-share-line", label: "Redes sociais" },
  { icon: "ri-article-line", label: "Blog" },
  { icon: "ri-image-2-line", label: "Portfólio" },
  { icon: "ri-shopping-bag-3-line", label: "Catálogo de produtos" },
  { icon: "ri-double-quotes-l", label: "Depoimentos" },
  { icon: "ri-pages-line", label: "Landing pages" },
  { icon: "ri-line-chart-line", label: "Integração com Analytics" },
  { icon: "ri-search-eye-line", label: "Google Search Console" },
  { icon: "ri-file-edit-line", label: "Formulários de orçamento" },
  { icon: "ri-mail-open-line", label: "Newsletter" },
  { icon: "ri-mail-send-line", label: "E-mail profissional" },
];

export const siteKinds = [
  {
    icon: "ri-building-2-line",
    title: "Site Institucional",
    description: "Para empresas que precisam apresentar sua marca, serviços, equipe e informações de contato.",
  },
  {
    icon: "ri-user-star-line",
    title: "Site Profissional",
    description: "Para profissionais liberais, especialistas e prestadores de serviços.",
  },
  {
    icon: "ri-window-line",
    title: "Landing Page",
    description: "Para campanhas, divulgação de serviços e geração de leads.",
  },
  {
    icon: "ri-shopping-bag-3-line",
    title: "Loja Virtual",
    description: "Para empresas que querem vender produtos pela internet.",
  },
  {
    icon: "ri-layout-grid-line",
    title: "Catálogo Online",
    description: "Para apresentar produtos e serviços de forma organizada.",
  },
  {
    icon: "ri-article-line",
    title: "Site + Blog",
    description: "Para empresas que desejam trabalhar conteúdo e SEO.",
  },
];

export const audience = [
  { icon: "ri-building-4-line", label: "Empresas" },
  { icon: "ri-tools-line", label: "Prestadores de serviços" },
  { icon: "ri-user-star-line", label: "Profissionais liberais" },
  { icon: "ri-hospital-line", label: "Clínicas" },
  { icon: "ri-briefcase-4-line", label: "Escritórios" },
  { icon: "ri-community-line", label: "Indústrias" },
  { icon: "ri-store-2-line", label: "Comércio" },
  { icon: "ri-restaurant-2-line", label: "Restaurantes" },
  { icon: "ri-home-office-line", label: "Imobiliárias" },
  { icon: "ri-map-pin-line", label: "Empresas locais" },
  { icon: "ri-shopping-bag-3-line", label: "Pequenos negócios" },
  { icon: "ri-rocket-2-line", label: "Empresas em crescimento" },
];

export const nxhostDifferentials = [
  {
    icon: "ri-eye-line",
    title: "Prévia inicial sem custo",
    description: "Conheça uma proposta visual antes de decidir pela contratação.",
  },
  {
    icon: "ri-palette-line",
    title: "Design personalizado",
    description: "Criamos uma identidade visual adequada ao posicionamento da sua empresa.",
  },
  {
    icon: "ri-cpu-line",
    title: "Tecnologia moderna",
    description: "Utilizamos tecnologias e boas práticas atuais para criar projetos modernos.",
  },
  {
    icon: "ri-speed-up-line",
    title: "Performance",
    description: "Priorizamos uma estrutura leve e otimizada.",
  },
  {
    icon: "ri-search-eye-line",
    title: "SEO",
    description: "Estrutura preparada para boas práticas de otimização para mecanismos de busca.",
  },
  {
    icon: "ri-smartphone-line",
    title: "Responsividade",
    description: "Seu site preparado para diferentes tamanhos de tela.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Segurança",
    description: "Aplicação de boas práticas de segurança e proteção.",
  },
  {
    icon: "ri-customer-service-2-line",
    title: "Suporte",
    description: "Conte com atendimento para evolução e manutenção do projeto.",
  },
];

export const beforeAfter = {
  before: {
    label: "Antes",
    title: "Presença digital básica",
    points: [
      "Site antigo e desorganizado",
      "Difícil de navegar",
      "Sem adaptação para celular",
      "Informações confusas",
    ],
    image:
      "https://readdy.ai/api/search-image?query=outdated%20cluttered%20old-fashioned%20website%20layout%20on%20a%20laptop%20screen%2C%20dull%20colors%2C%20messy%20typography%2C%20poor%20organization%2C%20unprofessional%20web%20design%20example&width=900&height=640&seq=nx-before-01&orientation=landscape&nocache=true",
  },
  after: {
    label: "Depois",
    title: "Experiência profissional",
    points: [
      "Site moderno e organizado",
      "Navegação clara e intuitiva",
      "Responsivo para o celular",
      "Rápido e com chamadas para ação",
    ],
    image:
      "https://readdy.ai/api/search-image?query=modern%20clean%20professional%20website%20homepage%20on%20a%20laptop%20screen%2C%20organized%20layout%2C%20blue%20accents%2C%20clear%20call%20to%20action%20buttons%2C%20elegant%20web%20design%20presentation&width=900&height=640&seq=nx-after-01&orientation=landscape&nocache=true",
  },
  note: "Exemplos ilustrativos criados pela NXHOST para demonstrar a diferença de padrão entre um projeto desatualizado e um projeto profissional. Não representam marcas ou sites reais.",
};

export const portfolioFilters = ["Todos", "Institucional", "Serviços", "Loja Virtual", "Landing Page"];

export const portfolioProjects = [
  {
    title: "Metalúrgica Prima",
    category: "Institucional",
    type: "Site institucional",
    description: "Site corporativo para indústria com catálogo de produtos, áreas de atuação e formulário de orçamento integrado.",
    image:
      "https://readdy.ai/api/search-image?query=modern%20corporate%20industrial%20website%20homepage%20displayed%20on%20a%20laptop%20screen%20in%20a%20bright%20minimal%20office%2C%20clean%20professional%20web%20design%2C%20blue%20accents%2C%20high%20detail&width=800&height=600&seq=nx-port-01&orientation=landscape",
  },
  {
    title: "Café do Vale",
    category: "Loja Virtual",
    type: "Loja virtual",
    description: "E-commerce de cafés especiais com carrinho, checkout, integração de pagamento e páginas de produto otimizadas.",
    image:
      "https://readdy.ai/api/search-image?query=minimal%20ecommerce%20coffee%20shop%20website%20on%20a%20smartphone%20screen%20on%20a%20wooden%20table%2C%20warm%20tones%2C%20clean%20product%20grid%20layout%2C%20professional%20photography&width=800&height=600&seq=nx-port-02&orientation=landscape",
  },
  {
    title: "Clínica Vitalis",
    category: "Landing Page",
    type: "Landing page",
    description: "Landing page de campanha para agendamento de consultas, com foco em conversão e integração com WhatsApp.",
    image:
      "https://readdy.ai/api/search-image?query=clean%20healthcare%20landing%20page%20design%20shown%20on%20a%20desktop%20monitor%20in%20a%20bright%20tidy%20clinic%20waiting%20room%2C%20soft%20neutral%20tones%2C%20professional%20web%20layout&width=800&height=600&seq=nx-port-03&orientation=landscape",
  },
  {
    title: "Studio Aurora",
    category: "Serviços",
    type: "Portfólio profissional",
    description: "Portfólio visual para escritório de arquitetura com galeria de projetos e apresentação de equipe.",
    image:
      "https://readdy.ai/api/search-image?query=elegant%20architecture%20studio%20portfolio%20website%20displayed%20on%20a%20tablet%20on%20a%20marble%20surface%20with%20soft%20natural%20light%2C%20minimal%20editorial%20layout%2C%20neutral%20tones&width=800&height=600&seq=nx-port-04&orientation=landscape",
  },
  {
    title: "Fit Mais Academia",
    category: "Institucional",
    type: "Site institucional",
    description: "Site com planos, horários, galeria de modalidades e captação de novos alunos pela internet.",
    image:
      "https://readdy.ai/api/search-image?query=modern%20fitness%20gym%20website%20homepage%20on%20a%20laptop%20screen%20on%20a%20dark%20desk%20with%20dramatic%20lighting%2C%20dynamic%20energetic%20layout%2C%20professional%20web%20design&width=800&height=600&seq=nx-port-05&orientation=landscape",
  },
  {
    title: "Móveis Lar & Estilo",
    category: "Loja Virtual",
    type: "Loja e catálogo",
    description: "Loja de móveis planejados com catálogo por ambiente, orçamento online e valorização da marca.",
    image:
      "https://readdy.ai/api/search-image?query=elegant%20furniture%20store%20website%20on%20a%20large%20monitor%20in%20a%20bright%20minimalist%20showroom%2C%20warm%20wooden%20textures%2C%20clean%20product%20catalog%20layout&width=800&height=600&seq=nx-port-06&orientation=landscape",
  },
  {
    title: "Advocacia Nunes",
    category: "Serviços",
    type: "Site profissional",
    description: "Site para escritório de advocacia com áreas de atuação, apresentação da equipe e canal de contato direto.",
    image:
      "https://readdy.ai/api/search-image?query=professional%20law%20firm%20website%20displayed%20on%20a%20laptop%20in%20an%20elegant%20minimal%20office%2C%20dark%20navy%20and%20warm%20neutral%20tones%2C%20sophisticated%20web%20design&width=800&height=600&seq=nx-port-07&orientation=landscape",
  },
  {
    title: "Construtora Horizonte",
    category: "Landing Page",
    type: "Landing page",
    description: "Landing page para lançamento imobiliário com galeria do empreendimento e captação de interessados.",
    image:
      "https://readdy.ai/api/search-image?query=real%20estate%20property%20launch%20landing%20page%20on%20a%20desktop%20screen%20in%20a%20bright%20modern%20office%2C%20clean%20architectural%20imagery%2C%20elegant%20conversion%20focused%20layout&width=800&height=600&seq=nx-port-08&orientation=landscape",
  },
];

export const techFlow = [
  { icon: "ri-global-line", label: "Domínio" },
  { icon: "ri-layout-masonry-line", label: "Site" },
  { icon: "ri-server-line", label: "Hospedagem" },
  { icon: "ri-search-eye-line", label: "SEO" },
  { icon: "ri-google-fill", label: "Google" },
  { icon: "ri-user-star-line", label: "Clientes" },
];

export const criacaoFaqs = [
  {
    question: "Quanto custa criar um site?",
    answer:
      "O investimento depende do tipo de site, quantidade de páginas, funcionalidades e necessidades do projeto. Solicite um orçamento personalizado para receber uma proposta adequada à sua empresa.",
  },
  {
    question: "Posso solicitar uma prévia antes de contratar?",
    answer:
      "Sim. A NXHOST oferece uma prévia visual inicial sem custo para que a empresa possa conhecer uma proposta antes de decidir pela contratação.",
  },
  {
    question: "A prévia é o site completo?",
    answer:
      "Não. A prévia serve para apresentar uma direção visual e estrutural inicial. O desenvolvimento completo depende do projeto contratado.",
  },
  {
    question: "O site funciona no celular?",
    answer: "Sim. Os projetos são desenvolvidos com design responsivo para diferentes dispositivos.",
  },
  {
    question: "O site é otimizado para SEO?",
    answer:
      "Os projetos podem ser estruturados seguindo boas práticas técnicas de SEO, com títulos, descrições, URLs amigáveis e estrutura semântica.",
  },
  {
    question: "Vocês também fazem hospedagem?",
    answer: "Sim. A NXHOST também oferece soluções de hospedagem, domínio e e-mail profissional.",
  },
  {
    question: "Posso colocar meu site no Google?",
    answer:
      "O site pode ser estruturado seguindo boas práticas de SEO e preparado para ferramentas como o Google Search Console. O posicionamento orgânico depende de diversos fatores e não deve ser garantido.",
  },
  {
    question: "Vocês criam lojas virtuais?",
    answer: "Sim. A NXHOST também desenvolve soluções de e-commerce, com catálogo, carrinho e checkout.",
  },
];

export const logoPortfolio = [
  {
    name: "NovaTech",
    segment: "Tecnologia",
    image:
      "https://readdy.ai/api/search-image?query=minimal%20geometric%20blue%20monogram%20logo%20mark%20for%20a%20fictitious%20technology%20brand%2C%20flat%20vector%20style%2C%20clean%20white%20background%2C%20professional%20branding%20presentation&width=400&height=400&seq=nx-logo-01&orientation=squarish",
  },
  {
    name: "Verde Vivo",
    segment: "Orgânicos",
    image:
      "https://readdy.ai/api/search-image?query=minimal%20leaf%20inspired%20green%20logo%20mark%20for%20a%20fictitious%20organic%20food%20brand%2C%20flat%20vector%20style%2C%20clean%20white%20background%2C%20professional%20branding%20presentation&width=400&height=400&seq=nx-logo-02&orientation=squarish",
  },
  {
    name: "Aurea Studio",
    segment: "Arquitetura",
    image:
      "https://readdy.ai/api/search-image?query=minimal%20geometric%20gold%20and%20dark%20logo%20mark%20for%20a%20fictitious%20architecture%20studio%2C%20flat%20vector%20style%2C%20clean%20white%20background%2C%20professional%20branding%20presentation&width=400&height=400&seq=nx-logo-03&orientation=squarish",
  },
  {
    name: "Sabor & Cia",
    segment: "Alimentação",
    image:
      "https://readdy.ai/api/search-image?query=minimal%20warm%20orange%20logo%20mark%20for%20a%20fictitious%20restaurant%20brand%2C%20flat%20vector%20style%2C%20clean%20white%20background%2C%20professional%20branding%20presentation&width=400&height=400&seq=nx-logo-04&orientation=squarish",
  },
  {
    name: "Lumière Beauty",
    segment: "Beleza",
    image:
      "https://readdy.ai/api/search-image?query=minimal%20elegant%20rose%20and%20neutral%20logo%20mark%20for%20a%20fictitious%20beauty%20brand%2C%20flat%20vector%20style%2C%20clean%20white%20background%2C%20professional%20branding%20presentation&width=400&height=400&seq=nx-logo-05&orientation=squarish",
  },
  {
    name: "Fortis Fit",
    segment: "Fitness",
    image:
      "https://readdy.ai/api/search-image?query=minimal%20bold%20dark%20and%20lime%20logo%20mark%20for%20a%20fictitious%20fitness%20brand%2C%20flat%20vector%20style%2C%20clean%20white%20background%2C%20professional%20branding%20presentation&width=400&height=400&seq=nx-logo-06&orientation=squarish",
  },
];

export const logoServices = [
  "Criação de logotipo",
  "Identidade visual",
  "Paleta de cores",
  "Tipografia da marca",
  "Manual de aplicação",
  "Aplicação em fachadas e redes sociais",
];